<template>
    <div class="recipesindex">
        <div class="top">
            <el-col :span="19">              
               <el-button type="primary" size="medium" @click="recipesadd()">添加</el-button>
               <el-button type="danger" size="medium" @click="deleteFoodss()">删除</el-button>
                <el-button type="primary" size="medium" @click="recipeslist()">学校菜品库</el-button>
            </el-col>
            <el-col :span="5">
                <el-input size="medium"  placeholder="请输入菜品名称" v-model.trim="listQuery.searchName" @change="handleFilter">
                  <el-button size="medium" slot="append" icon="el-icon-search" @click="handleFilter"></el-button>
                </el-input>
            </el-col>
        </div>			
        <el-table stripe :data="dataList"  :height="`${windowHeight-220}px`" border style="width: 100%"  @select="handleSelectionChange" @select-all="handleSelectionChange">
            <el-table-column type="selection" align="center" width="65px" :resizable="false"></el-table-column>   
            <el-table-column  label="菜品" show-overflow-tooltip  >
                <template slot-scope="scope">
                    {{scope.row.dietName}}
                </template>
            </el-table-column>  
           <el-table-column  label="图片"  align="center" >
                <template slot-scope="scope">
                    <img class="img" :src="scope.row.dietLogo" alt="">
                </template>
            </el-table-column>  
            <el-table-column label="类型" align="center">
                <template slot-scope="scope">
                        {{scope.row.dietTypeName}}
                </template>
            </el-table-column>   
            <el-table-column label="提供者" show-overflow-tooltip>
                <template slot-scope="scope">
                       {{scope.row.schoolName}}
                </template>
            </el-table-column> 
            <el-table-column  label="描述" show-overflow-tooltip  >
                <template slot-scope="scope">
                    {{scope.row.dietDes}}
                </template>
            </el-table-column>  
              <el-table-column label="操作" align="center">
                 <template slot-scope="scope">
                         <el-button  @click.native.prevent="deleteFoods(scope.row.id)"  type="text" size="small">删除</el-button>
                    </template>
            </el-table-column> 
        </el-table>
        <el-pagination
            class="pagination-container"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.pageNo"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</template>
<script>
    import {deleteDietCommon,dietCommonList} from '@/api/foodSetting';
    import mixin from '@/mixins/windowResize';
    export default {
        data() {
            return {
                listQuery: {
                    pageNo: 1,
                    pageSize: 20,
                    searchName: ''
                },
                dataList: [],
                total: null,
                mynum:0,
                selected:[],
                menuIds:""
            }
        },
        created() {
            this.queryFoodLists();
        },
        mixins: [mixin],       
        methods: { 
            //获取选中
            handleSelectionChange(val) {
                this.selected = val;
                this.menuIds='';
                for(let i=0;i<this.selected.length;i++){
                    if(i<this.selected.length-1){
                       this.menuIds+=this.selected[i].id+',';
                    }else{
                       this.menuIds+=this.selected[i].id; 
                    }
                };
               
            }, 
             //删除多条
            deleteFoodss(){
                if(this.selected.length==0){
                    this.$message({type: 'error', message:'请选择需要删除的菜品!'});
                    return;
                };
               this.$confirm('此操作将永久删除所选菜品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteDietCommon(this.menuIds).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.queryFoodLists();
                    }).catch();

                }).catch(() => {
                });
            },       
              //删除单条
            deleteFoods(id){
               this.$confirm('此操作将永久删除此菜品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteDietCommon(id).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.queryFoodLists();
                    }).catch();

                }).catch(() => {
                });
            },    
            //获取列表          
            queryFoodLists() {
                dietCommonList(this.listQuery)
                    .then(res => res.data)
                    .then(data => {
                        this.dataList = data.data.dataList;
                        this.total = data.data.pagination.total;
                    }).catch(err => {
                })
            },
            //搜索
            handleFilter (){
                this.listQuery.pageNo=1;
                this.queryFoodLists();
            }, 
            //切换码数          
            handleSizeChange(val) {
                this.listQuery.pageNo=1;
                this.listQuery.pageSize = val;
                this.queryFoodLists();
            },
            //切换页数
            handleCurrentChange(val) {
                this.listQuery.pageNo = val;
                this.queryFoodLists();
            },
            //学校菜品库
            recipeslist(){
                this.$router.push({
                    path: "recipeslist"
                });
            }, 
            //新增
            recipesadd(){
                this.$router.push({
                    path: "recipesadd"
                });
            },            
        }
    }
</script>
<style lang="scss" scoped>
.recipesindex{
   padding:12px;
    .pagination-container {
        margin-top: 10px;
    }
    .top{
        padding-bottom: 10px;
        overflow: hidden;
    }
    .img{
      width: 30px;
      height: 30px;
    }
    .link-type{
            cursor: pointer;
            color: #409eff;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/foodSetting/recipesindex.vue